let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fSuue")).then(() => parcelRequire('3ZjSN'));